// Order.js
import { useState, useEffect } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { debug, formatPrice, formatDate } from './../../utils';
// import OrderItem from './OrderItem';
// import './order-summary.css';
// import './order-items.css';
import API from '../../api';
const PendingOrder = () => {
  useEffect(() => {
  }, []);
  return (
    <div id="pending-order" className='construct text-left py-3 border rounded-3 mb-5'  >
      <div>
        Commande en cours ?
      </div>
      <div>
        <Link to="/formalities/request/fr1111111111111" as="a">Demande de test</Link>
      </div>
    </div >
  );
};
export default PendingOrder;